import { ClientErrors } from './ClientErrors.js';
import { DATA_LAYER_PAGE_TYPE_COOKIE_NAME } from './Constants.js';
import {
  extractDomain,
  getCookieValue,
  getLoggingHeaders,
  getTransactionId,
  getURLConfigs,
  logError,
  logInfo,
  setCookie,
  fetchWithTimeout,
} from './Utils.js';

export const EventType = {
  LOGIN: 'user_login',
  REGISTER: 'user_registration',
};

export function removeCookieByName(cookieName, cookieDomain) {
  const pastDate = new Date(0); // Set expiration to Jan 1, 1970
  setCookie(cookieName, '', pastDate, cookieDomain);
}

export async function addDataLayer() {
  try {
    const loginType = getCookieValue(DATA_LAYER_PAGE_TYPE_COOKIE_NAME);
    if (loginType === 'signin' || loginType === 'signup') {
      console.log(
        'sso-client - Inside addDataLayer calling datalayer api for loginType:',
        loginType,
      );
      const result = await fetchWithTimeout(
        `${getURLConfigs().BASE_URL_SSO}/datalayer`,
        {
          credentials: 'include',
          headers: {
            ...getLoggingHeaders(),
          },
        },
      );
      const dataLayerJson = await result.json();
      if (result.status === 200 && dataLayerJson.statusCode === 200) {
        if (loginType === 'signin') {
          createEvent(
            dataLayerJson.data.entity.fieldList.field,
            EventType.LOGIN,
            dataLayerJson.userId,
          );
        } else if (loginType === 'signup') {
          createEvent(
            dataLayerJson.data.entity.fieldList.field,
            EventType.REGISTER,
            dataLayerJson.userId,
          );
        }
        logInfo(
          `Inside addDataLayer, For GET_DATA_LAYER_API SUCCESS, added event for userId: ${dataLayerJson.userId} and eventType: ${loginType}`,
        );
        removeCookieByName(
          DATA_LAYER_PAGE_TYPE_COOKIE_NAME,
          extractDomain(getURLConfigs().BASE_URL_SSO),
        );
      } else {
        const transId = getTransactionId();
        logError(
          ClientErrors.GET_DATA_LAYER_NON_SUCCESS_STATUS,
          { dataLayerJson: dataLayerJson, status: result.status },
          transId,
        );
      }
    }
  } catch (error) {
    console.log(error);
    const transId = getTransactionId();
    logError(ClientErrors.GET_DATA_LAYER_FAILED, error, transId);
  }
}

function createEvent(data, type, userId) {
  if (type === EventType.LOGIN) {
    const dataLayerPush = {
      event: EventType.LOGIN,
      user: {
        customer_id: userId,
        login_status: 'signedIn', // default login status
        share_site: 'yes', // default share site status
        user_affiliation: getField(data, 'user_affiliation'),
        purchase_status: getField(data, 'userPurchaseClass'),
        login_method: getField(data, 'loginType'),
        registration_date: getField(data, 'regDate'),
        persistent_login: getField(data, 'persistent_login') === 'true',
        DNSS_opt_out: getField(data, 'DNSS_opt_out') === 'true',
        days_since_last_purchase:
          parseInt(getField(data, 'daysSinceLastPurchase')) || 0,
        days_since_last_login:
          parseInt(getField(data, 'days_since_last_login')) || 0,
        photos_in_account: parseInt(getField(data, 'photos_in_account')) || 0,
        days_since_last_upload:
          parseInt(getField(data, 'daysSinceLastUpload')) || 0,
        order_count: parseInt(getField(data, 'userPurchaseNumber')) || 0,
      },
    };
    // Push the dataLayer object to the window.dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(dataLayerPush);
  } else if (type === EventType.REGISTER) {
    const dataLayerPush = {
      event: EventType.REGISTER,
      registration: {
        step: 'confirm',
        customer_id: userId,
        user_affiliation: getField(data, 'user_affiliation'),
        registration_method: getField(data, 'loginType'),
        registration_date: getField(data, 'regDate'),
        DNSS_opt_out: getField(data, 'DNSS_opt_out') === 'true',
      },
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(dataLayerPush);
  }
}

function getField(data, fieldName) {
  const field = data.find((field) => field.name === fieldName);
  return field ? field.value : '';
}
